import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CustomPageRoutingModule } from './custom-routing.module';
import { CustomSignallerService } from './custom-signaller.service';

@NgModule({
  declarations: [],
  imports: [BrowserModule, CustomPageRoutingModule, CommonModule, FormsModule],
  providers: []
})
export class CustomModule {
    window:any=<any>window;
    constructor(
        public customsignaller: CustomSignallerService
    ) {
        this.customsignaller.initServices();
        this.window.custom = this.window.custom || {};

        this.window.document.addEventListener('flowup_update', async (ev) => {
            if(!this.window.usher.get()?.private_token) return;
            try {
                // CODICE
            } catch(e) {
                console.log(e);
            }
        });
    }
}